var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 20c-.167.333-.8 1-2 1-.8 0-1.667-.667-2-1m7.333-11.8c0-1.38-.562-2.702-1.562-3.677A5.4 5.4 0 0 0 12 3a5.4 5.4 0 0 0-3.771 1.523A5.14 5.14 0 0 0 6.667 8.2C6.667 14.267 4 17 4 17h16s-2.667-2.733-2.667-8.8",
    opacity: 0.4
  })));
};
export default SvgBellIcon;